import { render, staticRenderFns } from "./ListResearches.vue?vue&type=template&id=374fcf6a&scoped=true&"
import script from "./ListResearches.vue?vue&type=script&lang=js&"
export * from "./ListResearches.vue?vue&type=script&lang=js&"
import style0 from "./ListResearches.vue?vue&type=style&index=0&id=374fcf6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374fcf6a",
  null
  
)

export default component.exports